import React from "react";
import { Link, useLocation } from "react-router-dom";

const NAV_ITEMS = [
  { name: "Dashboard", path: "/dashboard", icon: "dashboard", excludeForAdmin: true },
  { name: "Chats", path: "/chats", icon: "chat_bubble" },
  { name: "Gerenciar IA", path: "/ia", icon: "psychology", excludeForAdmin: true },
  { name: "Perfil do Negócio", path: "/business-profile", icon: "person", excludeForAdmin: true },
  { name: "Contatos", path: "/contatos", icon: "contacts", excludeForAdmin: true },
  { name: "Métricas", path: "/analytics", icon: "monitoring", excludeForAdmin: true },
  { name: "Conectar WhatsApp", path: "/connect-whatsapp", icon: "settings_input_component", excludeForAdmin: true },
  { name: "Usuários", path: "/users", icon: "group", adminOnly: true },
  { name: "Administração", path: "/admin", icon: "admin_panel_settings", adminOnly: true },
];

const BOTTOM_ITEMS = [
  { name: "Ajuda", path: "/help", icon: "help" },
];

const Sidebar = ({ isOpen, onToggle, userRole }) => {
  const location = useLocation();

  const menuItems = NAV_ITEMS.filter((item) => {
    if (userRole === "admin") return item.adminOnly && !item.excludeForAdmin;
    return !item.adminOnly;
  });

  const isActive = (path) =>
    location.pathname === path ||
    (path === "/dashboard" && location.pathname === "/");

  return (
    <>
      {/* Sidebar */}
      <aside
        className={`fixed inset-y-0 left-0 z-50 flex flex-col h-full bg-surface-container-lowest font-headline antialiased
          transition-all duration-300
          ${isOpen ? "w-64 translate-x-0" : "-translate-x-full w-64"}
          lg:translate-x-0 ${isOpen ? "lg:w-64" : "lg:w-16"}`}
      >
        {/* Logo */}
        <div className="flex items-center gap-3 p-6 mb-2">
          {isOpen && (
            <h1 className="text-2xl font-bold tracking-tight text-white leading-none font-headline">PapIA</h1>
          )}
        </div>

        {/* Main nav */}
        <nav className="flex-1 min-h-0 overflow-y-auto px-3 space-y-1 pb-4">
          {menuItems.map((item) => {
            const active = isActive(item.path);
            return (
              <Link
                key={item.path}
                to={item.path}
                title={!isOpen ? item.name : undefined}
                className={`flex items-center gap-3 py-3 rounded-lg transition-all duration-200
                  ${isOpen ? 'px-4' : 'justify-center px-1'}
                  ${active
                    ? "bg-primary/10 text-primary border-r-2 border-primary font-semibold"
                    : "text-on-surface-variant hover:text-on-surface hover:bg-surface-container"
                  }`}
              >
                <span
                  className="material-symbols-outlined flex-shrink-0"
                  style={active ? { fontVariationSettings: "'FILL' 1" } : undefined}
                >
                  {item.icon}
                </span>
                {isOpen && <span className="text-sm truncate">{item.name}</span>}
              </Link>
            );
          })}
        </nav>

        {/* Bottom links */}
        <div className="px-3 pb-4 space-y-1 border-t border-outline-variant/10 pt-3">
          {BOTTOM_ITEMS.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              title={!isOpen ? item.name : undefined}
              className="flex items-center gap-3 px-4 py-3 rounded-lg text-on-surface-variant hover:text-on-surface hover:bg-surface-container transition-all duration-200"
            >
              <span className="material-symbols-outlined flex-shrink-0">{item.icon}</span>
              {isOpen && <span className="text-sm truncate">{item.name}</span>}
            </Link>
          ))}
        </div>

        {/* Collapse toggle */}
        <button
          onClick={onToggle}
          className="absolute top-20 -right-3 z-10 w-6 h-6 bg-surface-container-high border border-outline-variant/30 rounded-full flex items-center justify-center hover:bg-surface-bright transition-colors shadow-sm"
          title={isOpen ? "Recolher menu" : "Expandir menu"}
        >
          <span className="material-symbols-outlined text-on-surface-variant text-sm">
            {isOpen ? "chevron_left" : "chevron_right"}
          </span>
        </button>
      </aside>

      {/* Mobile overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={onToggle}
        />
      )}
    </>
  );
};

export default Sidebar;
